import { render, staticRenderFns } from "./ddmCulture2.vue?vue&type=template&id=5ee2cd09&scoped=true&"
import script from "./ddmCulture2.vue?vue&type=script&lang=js&"
export * from "./ddmCulture2.vue?vue&type=script&lang=js&"
import style0 from "./ddmCulture2.vue?vue&type=style&index=0&id=5ee2cd09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee2cd09",
  null
  
)

export default component.exports